"use client";

import { c as _c } from "react/compiler-runtime";
import { useQuery } from "@tanstack/react-query";
import { logAndThrow } from "@/src/lib/logging/logger";
import { getFaxLocationAssignment } from "@/src/requests/fax-location-assignment";
export const FAX_LOCATION_ASSIGNMENT_CACHE_KEY = "fax-location-assignment";
export function useFaxLocationAssignment(taskId, options) {
  const $ = _c(17);
  let t0;
  let t1;
  if ($[0] !== taskId) {
    t0 = [FAX_LOCATION_ASSIGNMENT_CACHE_KEY, taskId];
    t1 = async () => {
      if (!taskId) {
        logAndThrow("Task ID is required to fetch fax location assignment");
      }
      return await getFaxLocationAssignment(taskId);
    };
    $[0] = taskId;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  const t2 = options?.enabled !== false && !!taskId;
  let t3;
  if ($[3] !== t0 || $[4] !== t1 || $[5] !== t2) {
    t3 = {
      queryKey: t0,
      queryFn: t1,
      enabled: t2
    };
    $[3] = t0;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    data,
    isFetching,
    isLoading,
    isError
  } = useQuery(t3);
  const t4 = data?.referralLocation ?? null;
  const t5 = data?.authLocation ?? null;
  const t6 = data?.staffLocation ?? null;
  const t7 = data?.faxRecipientNumber ?? null;
  const t8 = data?.resolvedAssignment ?? null;
  const t9 = data?.locationPrefix ?? null;
  let t10;
  if ($[7] !== isError || $[8] !== isFetching || $[9] !== isLoading || $[10] !== t4 || $[11] !== t5 || $[12] !== t6 || $[13] !== t7 || $[14] !== t8 || $[15] !== t9) {
    t10 = {
      referralLocation: t4,
      authLocation: t5,
      staffLocation: t6,
      faxRecipientNumber: t7,
      resolvedAssignment: t8,
      locationPrefix: t9,
      isFetching,
      isLoading,
      isError
    };
    $[7] = isError;
    $[8] = isFetching;
    $[9] = isLoading;
    $[10] = t4;
    $[11] = t5;
    $[12] = t6;
    $[13] = t7;
    $[14] = t8;
    $[15] = t9;
    $[16] = t10;
  } else {
    t10 = $[16];
  }
  return t10;
}